<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddAir"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form :ref="refForm" :rules="rules" :model="airform" label-width="210px">
      <el-form-item :label="$t('desc.airCompressorSN')" prop="dsn">
        <el-input v-model="airform.dsn" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item prop="brandCode" :label="$t('title.brand')">
        <el-select
          style="width: 200px"
          @change="changeBrand"
          v-model="airform.brandCode"
          :placeholder="$t('desc.select')"
        >
          <el-option
            :label="brandInfo.brandName"
            :value="brandInfo.brandCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('title.airCompressorType')" prop="modelList">
        <el-cascader
          v-model="airform.modelList"
          :options="airModelOptions"
          filterable
          style="width: 100%"
          @change="modelChanged"
        ></el-cascader>
        <label
          style=" 
            vertical-align: middle;
            font-size: 12px;
            line-height: 1.4; 
            display:block;
            margin-top:5px;
          "
          >{{ modelInfo }}</label
        >
      </el-form-item>

      <el-form-item :label="$t('desc.customerName')" prop="customerId">
        <el-select
          v-model="airform.customerId"
          filterable
          :placeholder="$t('desc.select')"
          style="width: 100%"
          @change="custChanged"
        >
          <el-option
            v-for="item in custOption"
            :key="item.id"
            :label="containTranslate(item.customerName)"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('desc.compressorNumber')">
        <!-- <el-select
          v-model="airform.stationId"
          filterable
          :placeholder="$t('desc.select')"
          style="width: 200px"
        >
          <el-option v-for="item in stationOption"
                  :key="item.id"
                  :label="item.stationName"
                  :value="item.id"
                >
          </el-option>
        </el-select> -->
        <el-input
          v-model="airform.compressorNumber"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="客户代码">
        <el-input
          v-model="airform.customerCode"
          :disabled="true"
          style="width: 200px"
        ></el-input>
      </el-form-item> -->
      <el-form-item :label="$t('title.airCompressorService')">
        <el-select
          v-model="airform.serviceType"
          filterable
          :placeholder="$t('desc.select')"
          style="width: 300px"
        >
          <el-option value="" :label="$t('desc.select')"></el-option>
          <el-option
            v-for="item in ServiceList"
            :key="item.orderNum"
            :label="activeLang == 'zh' ? item.name : item.nameEng"
            :value="item.name"
          >
          </el-option>
          <!-- <el-option value="PackageCARE">PackageCARE</el-option>
          <el-option value="PlannedCARE Plus">PlannedCARE Plus</el-option>
          <el-option value="PlannedCare">PlannedCare</el-option>
          <el-option value="定期保养" :label="$t('desc.pmPureLabor')"></el-option>
          <el-option value="PartsCARE">PartsCARE</el-option>
          <el-option value="一次性保养" :label="$t('desc.oneTimePM')"></el-option>
          <el-option value="延长保修" :label="$t('desc.extendWarranty')"></el-option>
          <el-option value="工厂保内" :label="$t('desc.factoryWarranty')"></el-option>
          <el-option value="其他" :label="$t('desc.other')"></el-option> -->

          <!-- <el-option value="PackageCARE">PackageCARE</el-option>
          <el-option value="PLANNEDCARE(有延保)">PLANNEDCARE(有延保)</el-option>
          <el-option value="PLANNEDCARE(无延保)">PLANNEDCARE(无延保)</el-option>
          <el-option value="PARTSCARE">PARTSCARE</el-option>
          <el-option value="CARE(定期保养-纯服务)">CARE(定期保养-纯服务)</el-option>
          <el-option value="CARE(延长保修)">CARE(延长保修)</el-option>
          <el-option value="CARE(一次保养)">CARE(一次保养)</el-option>
          <el-option value="CARE(清洗服务)">CARE(清洗服务)</el-option>
          <el-option value="Ultimate CARE Pro(旗舰版)">Ultimate CARE Pro(旗舰版)</el-option>
          <el-option value="Ultimate CARE Select(精选版)">Ultimate CARE Select(精选版)</el-option>
          <el-option value="Ultimate CARE Lite(精简版)">Ultimate CARE Lite(精简版)</el-option>
          <el-option value="Ultimate CARE Labor(纯人工)">Ultimate CARE Labor(纯人工)</el-option>
          <el-option value="AOF/EMC">AOF/EMC</el-option>
          <el-option value="AIRCARE(定期保养)">AIRCARE(定期保养)</el-option>
          <el-option value="AIRCARE(定制保障)">AIRCARE(定制保障)</el-option>
          <el-option value="AIRCARE(全面保障)">AIRCARE(全面保障)</el-option>
          <el-option value="SELECTCARE(选项1)">SELECTCARE(选项1)</el-option>
          <el-option value="SELECTCARE(选项2)">SELECTCARE(选项2)</el-option>
          <el-option value="SELECTCARE(选项3)">SELECTCARE(选项3)</el-option> -->
          <el-option value="其他" :label="$t('desc.other')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('title.controlsSN')">
        <el-input v-model="airform.hardwareSn" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('title.controlsCCN')">
        <el-select
          v-model="airform.ccn"
          filterable
          :placeholder="$t('desc.select')"
          style="width: 200px"
          @change="ccnChange"
        >
          <el-option
            v-for="item in ccnList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <label
          style="
            text-align: right;
            vertical-align: middle;
            line-height: 32px;
            padding: 0 12px 0 20px;
            box-sizing: border-box;
            font-size: 14px;
            color: #bfc0c9;
          "
          >{{ $t("title.ccnVersion") }}</label
        >
        <el-select
          v-model="airform.ccnVersion"
          filterable
          :placeholder="$t('desc.select')"
        >
          <el-option
            v-for="item in ccnVersionOptions"
            :key="item.version"
            :label="item.version"
            :value="item.version"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          v-if="subButtonAuth"
          type="success"
          :loading="loading"
          @click="onSubBtn(refForm)"
          >{{ $t("button.confirm") }}</el-button
        >
        <el-button @click="doClose">{{ $t("button.cancel") }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  getAllCustomer,
  getBrandInfos,
  getServiceTypeList,
  getDeviecModelTree,
  getDeviceModelType,
  getDeviceModels,
} from "../../../api/api";
export default {
  name: "index",
  props: {
    activeLang: "",
    loading: false,
    subButtonAuth: false,
    isEditChange: false,
    refForm: "",
    title: "",
    dialogAddAir: false,
    airform: {
      Dsn: {
        type: String,
        required: true,
      },
      ModelId: "",
      ModelList: [],
      CustomerId: "",
      ServiceType: "",
      Ccn: "",
      CustomerName: "",
      CustomerCode: "",
      StationId: "",
      HardwareSn: "",
    },
    ccnList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    stationOption: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ccnVersionOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    dialogAddAir: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          if (!this.custOption || this.custOption.length <= 0) {
            this.getCustOption();
          }
          if (!this.ServiceList || this.ServiceList.length <= 0) {
            this.getServiceTypeList();
          }
          if (!this.airModelOptions || this.airModelOptions.length <= 0) {
            this.getDeviecModelTree();
          }
          this.getBrandInfos();
        }
      },
      deep: true,
    },
    isEditChange: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.modelChanged();
        }
      },
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("tips.needed")));
      }
    };
    return {
      rules: {
        brandCode: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["blur", "change"],
          },
        ],
        dsn: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" },
        ],
        modelList: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["blur", "change"],
          },
        ],
        // customerId:[{required:true, message: '不能为空', trigger: ['blur','change']}],
      },
      custOption: [],
      custOptionShow: [],
      brandInfo: {},
      ServiceList: [],
      airoptions: [],
      airModelOptions: [],
      deviceModelTypeList: [],
      deviceModelOption: [],
      modelInfo: "",
      isShowccn:true,
    };
  },
  methods: {
    getCustOption() {
      let that = this;
      getAllCustomer().then((res) => {
        let data = res.result;
        that.custOption = data;
        for (let index = 0; index < data.length; index++) {
          that.custOption[index].customerName =
            data[index].customerCode +
            "_" +
            data[index].customerName +
            "_" +
            data[index].companyType +
            "_" +
            data[index].manageCpName;
        }
      });
    },
    getDeviecModelTree() {
      let that = this;
      getDeviecModelTree(this.activeLang).then((res) => {
        let data = res.result;
        that.airoptions = data;
        let brand = localStorage.getItem("user_brand")
          ? localStorage.getItem("user_brand")
          : "IR";
        this.airModelOptions = this.airoptions.filter((x) => x.brand == brand);
      });
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      let brandCode = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
      that.brandInfo = res.result.find((x) => x.brandCode == brandCode);
    },
    async getServiceTypeList() {
      let that = this;
      let res = await getServiceTypeList();
      that.ServiceList = res.result;
    },
    async getDeviceModelOption() {
      let that = this;
      let res = await getDeviceModels();
      that.deviceModelOption = res.result;
    },
    custChanged(value) {
      // let custCode="";
      // for (let index = 0; index < this.custOption.length; index++) {
      //     if (this.custOption[index].id==value) {
      //         custCode=this.custOption[index].customerCode
      //     }
      // }
      // this.airform.customerCode=custCode;
      this.$emit("custChanged", value);
    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.modelInfo = "";
      this.custOptionShow = [];
      this.$emit("dialogVisibleEvent", false);
      var ref = this.refForm;
      this.$refs[ref].resetFields();
    },
    ccnChange(value) {
      this.$emit("ccnChange", value);
    },
    changeBrand() {
      this.$emit("changeBrand", true);
    },
    async modelChanged() {
      let that = this;
      let curModelType = '';
      if (that.airform.modelList && that.airform.modelList.length > 0) {
        let curId = that.airform.modelList[that.airform.modelList.length - 1];
        if (that.deviceModelOption.length === 0) {
          await that.getDeviceModelOption();
        }
        let curModel = that.deviceModelOption.find((x) => x.id == curId);
        this.modelInfo =
          this.$t("title.productFamily") +
          this.$t("title.colon") +
          (curModel.productFamily ? curModel.productFamily : "-") +
          " " +
          this.$t("title.power") +
          this.$t("title.colon") +
          curModel.power +
          " " +
          this.$t("title.dischargePressure") +
          this.$t("title.colon") +
          curModel.dischargePressure +
          " " +
          this.$t("title.coolingMode") +
          this.$t("title.colon") +
          (curModel.coolingMode ? curModel.coolingMode : "-");
      }
      if (this.airform.modelList) {
        if (that.deviceModelTypeList.length === 0) {
          await that.getDeviceModelType();
        }
        curModelType = that.deviceModelTypeList.find(
          (a) => a.id === this.airform.modelList[0]
        )?.type;
        if (curModelType === "离心机") {
          that.custOptionShow = that.custOption.filter(
            (a) => a.customerType === "PAC"
          );
        } else {
          that.custOptionShow = that.custOption.filter(
            (a) => a.customerType !== "PAC"
          );
        }
      }
      if (that.airModelOptions.find(a=>a.value == that.airform.modelList[0])?.label == "离心机") {
        this.isShowccn = false;
      }else{
        this.isShowccn = true;
      }
      this.$emit("changeModel", curModelType);
    },
    async getDeviceModelType() {
      let that = this;
      let res = await getDeviceModelType();
      that.deviceModelTypeList = res.result;
    },
    containTranslate(str) {
      let containArr = ['直管', '经销商', '服务经销商', '中间商', '其他'];
      let result="";
      containArr.forEach(element=>{
        if (str.indexOf(element) > -1) {
          let displayStr = this.$t('desc.'+element);
          result = str.replace(element,displayStr);
        }
      });
      return result;
    }
  },
};
</script>

<style scoped>
.infodiv {
  margin-top: 5px;
  border: 1px solid #d2d2d2;
  padding: 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
